"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef, useState } from "react";
import Image from "next/image";
import Link from "next/link";
interface UserMenuSession {
  name?: string | null;
  email?: string | null;
  image?: string | null;
}
interface UserMenuProps {
  session: UserMenuSession;
  isAdmin?: boolean;
}

/**
 * Avatar button that opens the account menu. Replaces the bare "Dashboard"
 * link, which left users with no way to sign out.
 */
export function UserMenu(t0) {
  const $ = _c(31);
  const {
    session,
    isAdmin: t1
  } = t0;
  const isAdmin = t1 === undefined ? false : t1;
  const [open, setOpen] = useState(false);
  const menuRef = useRef(null);
  let t2;
  let t3;
  if ($[0] !== open) {
    t2 = () => {
      if (!open) {
        return;
      }
      const onPointerDown = function onPointerDown(event) {
        if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
          setOpen(false);
        }
      };
      const onKeyDown = function onKeyDown(event_0) {
        if (event_0.key === "Escape") {
          setOpen(false);
        }
      };
      document.addEventListener("mousedown", onPointerDown);
      document.addEventListener("keydown", onKeyDown);
      return () => {
        document.removeEventListener("mousedown", onPointerDown);
        document.removeEventListener("keydown", onKeyDown);
      };
    };
    t3 = [open];
    $[0] = open;
    $[1] = t2;
    $[2] = t3;
  } else {
    t2 = $[1];
    t3 = $[2];
  }
  useEffect(t2, t3);
  let t4;
  if ($[3] !== session.email || $[4] !== session.name) {
    t4 = session.name?.charAt(0) || session.email?.charAt(0) || "U";
    $[3] = session.email;
    $[4] = session.name;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const initial = t4;
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => setOpen(_temp);
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== initial || $[8] !== session.image || $[9] !== session.name) {
    t6 = session.image ? <Image src={session.image} alt={session.name || "User"} width={20} height={20} className="rounded-full ring-2 ring-white/20" /> : <div className="w-5 h-5 bg-blue-400/30 rounded-full flex items-center justify-center text-xs font-bold">{initial}</div>;
    $[7] = initial;
    $[8] = session.image;
    $[9] = session.name;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== session.name) {
    t7 = session.name?.split(" ")[0] || "Account";
    $[11] = session.name;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t7) {
    t8 = <span className="hidden sm:inline">{t7}</span>;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  const t9 = `w-3.5 h-3.5 transition-transform ${open ? "rotate-180" : ""}`;
  let t10;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== t9) {
    t11 = <svg className={t9} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5} aria-hidden="true">{t10}</svg>;
    $[16] = t9;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== open || $[19] !== t11 || $[20] !== t6 || $[21] !== t8) {
    t12 = <button type="button" onClick={t5} aria-haspopup="menu" aria-expanded={open} aria-label="Account menu" className="flex items-center gap-2 px-3.5 py-2 bg-gradient-to-r from-blue-600 to-blue-500 hover:from-blue-500 hover:to-blue-400 text-white rounded-lg text-sm font-medium transition-all shadow-lg shadow-blue-600/20">{t6}{t8}{t11}</button>;
    $[18] = open;
    $[19] = t11;
    $[20] = t6;
    $[21] = t8;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== isAdmin || $[24] !== open || $[25] !== session.email || $[26] !== session.name) {
    t13 = open && <div role="menu" className="absolute right-0 mt-2 w-56 rounded-xl border border-gray-700/60 bg-gray-900 shadow-2xl shadow-black/40 py-1.5 z-50"><div className="px-3.5 py-2.5 border-b border-gray-700/60"><p className="text-sm font-medium text-white truncate">{session.name || "Signed in"}</p>{session.email ? <p className="text-xs text-gray-400 truncate">{session.email}</p> : null}</div><Link href="/dashboard" role="menuitem" onClick={() => setOpen(false)} className="block px-3.5 py-2 text-sm text-gray-300 hover:bg-gray-800 hover:text-white transition-colors">Dashboard</Link><Link href="/settings" role="menuitem" onClick={() => setOpen(false)} className="block px-3.5 py-2 text-sm text-gray-300 hover:bg-gray-800 hover:text-white transition-colors">Settings</Link>{isAdmin ? <Link href="/admin" role="menuitem" onClick={() => setOpen(false)} className="block px-3.5 py-2 text-sm text-gray-300 hover:bg-gray-800 hover:text-white transition-colors">Admin</Link> : null}<div className="border-t border-gray-700/60 mt-1.5 pt-1.5"><form action="/api/auth/logout" method="POST"><button type="submit" role="menuitem" className="w-full text-left px-3.5 py-2 text-sm text-red-400 hover:bg-red-500/10 hover:text-red-300 transition-colors">Sign out</button></form></div></div>;
    $[23] = isAdmin;
    $[24] = open;
    $[25] = session.email;
    $[26] = session.name;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] !== t12 || $[29] !== t13) {
    t14 = <div className="relative" ref={menuRef}>{t12}{t13}</div>;
    $[28] = t12;
    $[29] = t13;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  return t14;
}
function _temp(v) {
  return !v;
}